// @flow
import SectionGeneral from './SectionGeneral';

export default SectionGeneral;
